import React from "react";
import PropTypes from "prop-types";
import  IframeCard  from "../../components/IframeCard";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Input,
  Row,
  Col
} from "reactstrap";

const InfoComponent = ({
  onChange,
  onClick,
  onCancel,
  image,
  preview
}) => {
  return (
    <Row>
      <Col>
        <Card>
          <CardHeader>
            <h5 className="title">Informativo</h5>
          </CardHeader>
          <CardBody>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                onClick();
              }}
            >    
              <IframeCard onRefresh={preview} />
              <Row>
                <Col xs={12} md={6}>
                  <FormGroup>
                    <span>Título</span>
                    <Input
                      name="noticeTitle"
                      type="text"
                      placeholder="Título"
                      value={image?.noticeTitle}
                      onChange={(e) => onChange(e)}
                    />
                  </FormGroup>
                </Col>
                <Col xs={12} md={6}>
                  <FormGroup>
                    <span>Tempo de exibição (em segundos)</span>
                    <Input
                      name="showTime"
                      type="number"
                      placeholder="Tempo de exibição"
                      value={image?.showTime}
                      onChange={(e) => onChange(e)}
                    />
                  </FormGroup>
                </Col>
                <Col xs={12} md={12}>
                  <FormGroup>
                    <span>Informativo</span>
                    <textarea className="form-control text-area-notice" value={image?.noticeMessage} onChange={(e) => onChange(e)} id="noticeMessage" name="noticeMessage" rows={5}/>
                  </FormGroup>
                </Col>    
              </Row>
              <Row>
                <Col style={{textAlign: "right"}}>
                  <Button
                    className="btn-fill btn-xs"
                    color="danger"
                    type="button"
                    onClick={()=>onCancel()}
                  >
                    Voltar
                  </Button>
                  <Button
                    className="btn-fill btn-xs"
                    color="primary"
                    type="submit"
                  >
                    Salvar
                  </Button>
                </Col>
              </Row>                  
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

InfoComponent.propTypes = {
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  image: PropTypes.object.isRequired
};

export default InfoComponent;